module.exports = "/v2/pages/dashboard/dist/3b02e10978751421a7c97c0fde06817f.svg";